<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="900px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Duomenų naikinimo aktas archyvarui</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-row align="baseline" class="mb-0">
              <v-col cols="12" class="mb-2">
                Ar tikrai norite suformuoti archyvo duomenų naikinimo aktą
                archyvarui?
              </v-col>
              <v-col cols="12" md="12" class="mb-4">
                <el-radio-group
                  inline
                  class="my-2"
                  :items="objektasTipas"
                  required
                  :hide-details="false"
                  v-model="objektoTipas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Išregistravimo metai"
                  tooltip="Archyvo naikinimas. Archyvaro aktas. Išregistravimo metai"
                  v-mask="`####`"
                  placeholder="MMMM"
                  :min-year="minYear"
                  required
                  v-model="formData.nak_metai"
                />
              </v-col>
              <v-col cols="12" md="8">
                <el-autocomplete
                  :items="filteredPadaliniai"
                  itemvalue="value"
                  itemtext="text"
                  multiple
                  label="Padalinys"
                  tooltip="Archyvo naikinimas. Archyvaro aktas. Padalinys"
                  :disabled="disabledPadaliniai"
                  :required="!disabledPadaliniai"
                  v-model="formData.nak_padaliniai"
                />
              </v-col>
              <!-- <v-col cols="12" md="2" class="mt-2">
                <el-checkbox label="Visi padaliniai" v-model="visiPadaliniai" />
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()" :loading="loading">
          Atšaukti
        </el-button>
        <el-button primary :loading="loading" @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalAktasArchyvaras',
  props: {
    value: Boolean,
    loading: Boolean,
    padaliniai: Object,
  },
  data() {
    return {
      formData: {
        nak_objekto_tipas: null,
        nak_metai: null,
        nak_padaliniai: null,
      },
      tempPadaliniai: [],
      visiPadaliniai: false,
      objektoTipas: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['prasymasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.formData = {
          nak_objekto_tipas: null,
          nak_metai: null,
          nak_padaliniai: null,
        }
        this.visiPadaliniai = false
        this.$validator.reset()
        this.$emit('input', value)
      },
    },
    objektasTipas() {
      return [
        {
          label: 'Hipotekos / įkeitimai',
          tooltip: 'Archyvo naikinimas. Archyvaro aktas. Hipotekos / įkeitimai',
          value: 1,
        },
        {
          label: 'Neregistruojamų daiktų sutartys',
          tooltip:
            'Archyvo naikinimas. Archyvaro aktas. Neregistruojamų daiktų sutartys',
          value: 2,
        },
      ]
    },
    filteredPadaliniai() {
      return Object.entries(this.padaliniai).map(([key, item]) => {
        return { value: key, text: item }
      })
    },
    disabledPadaliniai() {
      return this.formData.nak_objekto_tipas === 2
    },
    minYear() {
      if (process.env.VUE_APP_LOCAL === 'develop') {
        return 2020
      }
      return 2022
    },
  },
  watch: {
    visiPadaliniai(val) {
      this.formData.visi_padaliniai = val
      if (val) {
        this.tempPadaliniai = this.formData.nak_padaliniai
        this.formData.nak_padaliniai = []
        return
      }
      this.formData.nak_padaliniai = this.tempPadaliniai
    },
    objektoTipas(val) {
      this.formData.nak_objekto_tipas = val
      if (this.disabledPadaliniai) {
        this.formData.nak_padaliniai = null
      }
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          window._VMA.$emit('FORMAT_ERROR')
          return
        }

        const data = {
          ...this.formData,
        }
        this.$emit('confirmAktasArchyvarui', data)
      })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
